<template>
  <div class="w-full mt-5">
    <!-- Article cards skeleton grid -->
    <div class="flex flex-wrap justify-between gap-x-16 gap-y-5">
      <div
        v-for="i in 10"
        :key="`article-skeleton-${i}`"
        class="article-card-skeleton md:w-[calc(50%-32px)]"
      >
        <div class="article-card-skeleton__link">
          <div class="article-card-skeleton__image-link">
            <div class="article-card-skeleton__image loading-effect"></div>
          </div>
          <div class="article-card-skeleton__content">
            <!-- Author skeleton -->
            <div class="article-card-skeleton__author loading-effect"></div>

            <!-- Title skeleton -->
            <div class="article-card-skeleton__title">
              <div
                class="article-card-skeleton__title-inner loading-effect"
              ></div>
            </div>

            <!-- Description skeleton -->
            <div class="article-card-skeleton__text loading-effect"></div>

            <!-- Date skeleton -->
            <div class="article-card-skeleton__date loading-effect"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination skeleton -->
    <div
      class="mt-20 text-center flex flex-col md:flex-row justify-center items-center gap-6"
    >
      <!-- Show More button skeleton -->
      <div class="loading-effect min-w-[150px] h-[40px] rounded-sm"></div>

      <!-- Pagination controls skeleton -->
      <div class="flex gap-2">
        <div class="loading-effect w-8 h-8 rounded-sm"></div>
        <div class="loading-effect w-8 h-8 rounded-sm"></div>
        <div class="loading-effect w-8 h-8 rounded-sm"></div>
        <div class="loading-effect w-8 h-8 rounded-sm"></div>
        <div class="loading-effect w-8 h-8 rounded-sm"></div>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
@import '~/assets/css/loading.css';
@reference '~/assets/css/tailwind.css';

.article-card-skeleton {
  &__link {
    @apply flex gap-2;
  }

  &__image-link {
    @apply flex min-w-[160px] w-[160px] h-[128px] rounded-lg overflow-hidden;
  }

  &__image {
    @apply w-full h-full;
  }

  &__content {
    @apply flex flex-col flex-1;
  }

  &__author {
    @apply w-24 h-3 mb-2;
  }

  &__title {
    line-height: 125%;
  }

  &__title-inner {
    @apply text-sm font-medium w-full h-4 mb-2;
  }

  &__text {
    @apply hidden md:block w-full h-3 mb-1;
  }

  &__date {
    @apply mt-auto w-20 h-3;
  }
}
</style>
